import React, { useState } from "react";

interface Tab {
  id: string;
  label: string;
  component: React.FC;
}

interface VerticalTabsProps {
  tabs: Tab[];
  title?: string;
}

const VerticalTabs: React.FC<VerticalTabsProps> = ({ tabs, title }) => {
  const [activeTab, setActiveTab] = useState<string>(tabs[0]?.id || "");

  return (
    <div className="flex bg-gray-100 items-stretch min-h-screen">
      {/* Sidebar */}
      <div className="w-72 p-4 bg-gray-300 shadow-lg">
        {title && <h3 className="font-semibold mb-6">{title}</h3>}
        <nav className="flex flex-col space-y-2 grow">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-3 py-2 text-left font-medium rounded-lg transition-all duration-300 ${
                activeTab === tab.id
                  ? "bg-slate-700 text-white shadow-md"
                  : "hover:bg-slate-500 hover:text-gray-200"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Right Panel */}
      <div className="flex-1 p-8 bg-white shadow-md rounded-lg m-6 h-fit min-h-screen overflow-hidden">
        {tabs.map(
          (tab) => activeTab === tab.id && <tab.component key={tab.id} />
        )}
      </div>
    </div>
  );
};

export default VerticalTabs;
